(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["azuelos-mode"] && !Shopify.designMode) return;
  try {
    
function initAzuelosMode(root){
  if(root.dataset.azInitialized)return;
  root.dataset.azInitialized='true';
  const motion=root.querySelector('[data-az-motion]');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  let moving=root.dataset.motionEnabled==='true'&&!reduced.matches;
  let onScreen=true;
  function setMotion(){
    root.classList.toggle('az-moving',moving&&!document.hidden);
    root.classList.toggle('az-hero-active',onScreen);
    motion.setAttribute('aria-pressed',String(!moving));
    motion.setAttribute('aria-label',moving?motion.dataset.pause:motion.dataset.resume);
    motion.querySelector('[data-motion-text]').textContent=moving?motion.dataset.pauseShort:motion.dataset.resumeShort;
    motion.querySelector('[data-motion-icon]').textContent=moving?'Ⅱ':'▷';
    root.querySelectorAll('video').forEach(video=>{if(moving&&onScreen&&!document.hidden&&!video.closest('[hidden]'))video.play().catch(()=>{});else video.pause();});
  }
  motion.addEventListener('click',()=>{moving=!moving;root.classList.toggle('az-manual-motion',moving&&reduced.matches);setMotion();});
  reduced.addEventListener('change',()=>{moving=root.dataset.motionEnabled==='true'&&!reduced.matches;root.classList.remove('az-manual-motion');setMotion();});
  root.querySelectorAll('[data-az-slide]').forEach(button=>button.addEventListener('click',()=>{
    root.querySelectorAll('[data-az-frame]').forEach(frame=>{frame.hidden=frame.dataset.azFrame!==button.dataset.azSlide;});
    root.querySelectorAll('[data-az-slide]').forEach(tab=>{tab.setAttribute('aria-pressed',String(tab===button));});
    setMotion();
  }));
  root.querySelectorAll('[data-az-category]').forEach(link=>{
    const show=()=>root.querySelectorAll('[data-az-preview]').forEach(image=>{image.hidden=image.dataset.azPreview!==link.dataset.azCategory;});
    link.addEventListener('mouseenter',show);link.addEventListener('focus',show);
  });
  if('IntersectionObserver'in window){
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('az-visible');observer.unobserve(entry.target);}}),{threshold:.04});
    root.querySelectorAll('.az-reveal').forEach(element=>observer.observe(element));
    const heroObserver=new IntersectionObserver(entries=>{onScreen=entries[0].isIntersecting;setMotion();},{threshold:0});
    heroObserver.observe(root.querySelector('.az-hero'));
    const marqueeObserver=new IntersectionObserver(entries=>root.classList.toggle('az-marquee-active',entries[0].isIntersecting),{threshold:0});
    marqueeObserver.observe(root.querySelector('.az-marquee'));
    root.classList.add('az-ready');
  }
  document.addEventListener('visibilitychange',()=>{onScreen=!document.hidden&&root.querySelector('.az-hero').getBoundingClientRect().bottom>0;setMotion();});
  setMotion();
}
document.querySelectorAll('[data-az-mode]').forEach(initAzuelosMode);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-az-mode]').forEach(initAzuelosMode));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["azuelos-octobre-rose"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Europe/Paris: October begins in UTC+02 and November begins in UTC+01.
    const startsAt = Date.parse('2026-10-01T00:00:00+02:00');
    const endsAt = Date.parse('2026-11-01T00:00:00+01:00');
    let timer;
    const updateCampaign = () => {
      clearTimeout(timer);
      const now = Date.now();
      const active = now >= startsAt && now < endsAt;
      document.querySelectorAll('[data-az-octobre-rose]').forEach((banner) => {
        banner.hidden = !active;
      });
      const nextBoundary = now < startsAt ? startsAt : endsAt;
      if (now < nextBoundary) {
        timer = setTimeout(updateCampaign, Math.min(nextBoundary - now + 50, 2147483647));
      }
    };
    updateCampaign();
    document.addEventListener('visibilitychange', updateCampaign);
    document.addEventListener('shopify:section:load', updateCampaign);
    window.addEventListener('pageshow', updateCampaign);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["azuelos-resellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('azuelos-pro-order')) {
    customElements.define('azuelos-pro-order', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
        this.rows = [...this.querySelectorAll('[data-row]')];
        this.busy = false; this.locked = false;
        this.form = this.querySelector('[data-order-form]');
        this.submit = this.querySelector('[data-submit]');
        this.cartCount = Number(this.dataset.cartCount) || 0;
        this.formatter = new Intl.NumberFormat(this.dataset.locale || 'fr', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        const options = { signal: this.controller.signal };
        this.addEventListener('input', event => this.onInput(event), options);
        this.addEventListener('change', event => this.onChange(event), options);
        this.addEventListener('click', event => this.onClick(event), options);
        this.form.addEventListener('submit', event => this.addSelection(event), options);
        this.querySelector('[data-tools]').hidden = false;
        this.querySelector('[data-summary]').hidden = false;
        this.rows.forEach(row => this.syncRow(row));
        this.update();
      }
      disconnectedCallback() { this.controller?.abort(); this.request?.abort(); this.controller = null; }
      text(key, values = {}) { return Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`__${name}__`, String(value)), this.messages[key] || ''); }
      quantity(row) { return Number(row.querySelector('[data-quantity]').value) || 0; }
      limits(row) {
        const inCart = Number(row.dataset.inCart) || 0;
        const step = Number(row.dataset.step) || 1;
        const minimum = Number(row.dataset.min) || 1;
        const first = Math.ceil(Math.max(inCart + 1, minimum) / step) * step - inCart;
        let maximum = row.dataset.max === '' ? Infinity : Math.max(0, Number(row.dataset.max) - inCart);
        if (row.dataset.stock !== '') maximum = Math.min(maximum, Math.max(0, Number(row.dataset.stock) - inCart));
        if (row.dataset.available !== 'true') maximum = 0;
        return { first, maximum, step, inCart, minimum };
      }
      valid(row) {
        const input = row.querySelector('[data-quantity]');
        const value = Number(input.value);
        const { first, maximum, step, inCart } = this.limits(row);
        return input.value !== '' && Number.isSafeInteger(value) && value >= 0 && (value === 0 || (value >= first && value <= maximum && (inCart + value) % step === 0));
      }
      syncRow(row) {
        const { first, maximum, step } = this.limits(row);
        const value = this.quantity(row);
        const input = row.querySelector('[data-quantity]');
        const inactive = this.busy || this.locked;
        input.disabled = inactive || (maximum < first && value === 0);
        input.max = Number.isFinite(maximum) ? String(maximum) : '';
        row.querySelector('[data-minus]').disabled = inactive || value <= 0;
        row.querySelector('[data-plus]').disabled = inactive || maximum < first || (value === 0 ? first : value + step) > maximum;
        const valid = this.valid(row);
        input.setAttribute('aria-invalid', String(!valid));
        row.querySelector('[data-row-error]').textContent = valid ? '' : this.text('error_quantity', { min: first, step, max: Number.isFinite(maximum) ? maximum : this.text('unlimited') });
      }
      filter() {
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        const search = normalize(this.querySelector('[data-search]').value.trim());
        const available = this.querySelector('[data-available]').checked;
        const selected = this.querySelector('[data-selected]').checked;
        let count = 0;
        this.rows.forEach(row => {
          const limit = this.limits(row);
          row.hidden = (search !== '' && !normalize(row.dataset.searchText).includes(search)) || (available && limit.maximum < limit.first) || (selected && this.quantity(row) === 0);
          if (!row.hidden) count++;
        });
        this.querySelector('[data-results]').textContent = this.text('results', { count });
        this.querySelector('[data-empty]').hidden = count !== 0;
      }
      update() {
        let count = 0, subtotal = 0;
        for (const row of this.rows) { this.syncRow(row); if (this.valid(row)) { const quantity = this.quantity(row); count += quantity; subtotal += quantity * Number(row.dataset.price); } }
        this.selectedCount = count;
        this.querySelector('[data-selected-count]').textContent = this.text('selected_count', { count });
        this.querySelector('[data-cart-count-label]').textContent = this.text('existing_cart', { count: this.cartCount });
        this.querySelector('[data-subtotal]').textContent = this.formatter.format(subtotal / 100);
        const total = count + this.cartCount;
        this.querySelector('[data-progress]').style.width = `${Math.min(100, Math.max(0, total * 10))}%`;
        this.querySelector('[data-progress-note]').textContent = total >= 10 ? this.text('minimum_reached') : this.text('minimum_remaining', { count: 10 - total });
        this.submit.disabled = this.busy || this.locked || count === 0 || this.rows.some(row => !this.valid(row));
        this.submit.textContent = this.text(this.busy ? 'adding' : 'add');
        this.querySelector('[data-clear]').disabled = this.busy || this.locked || !this.rows.some(row => row.querySelector('[data-quantity]').value !== '0');
        this.filter();
      }
      message(key) { const region = this.querySelector('[data-message]'); region.textContent = this.text(key); this.querySelector('[data-check-account]').hidden = key !== 'error_session'; region.focus({ preventScroll: false }); }
      onInput(event) { if (event.target.matches('[data-search]')) this.filter(); else if (event.target.matches('[data-quantity]')) { this.querySelector('[data-message]').textContent = ''; this.update(); } }
      onChange(event) { if (event.target.matches('[data-available],[data-selected]')) this.filter(); }
      onClick(event) {
        const action = event.target.closest('[data-minus],[data-plus],[data-clear],[data-page-link]');
        if (!action) return;
        if (action.matches('[data-page-link]')) { if (this.selectedCount > 0) { event.preventDefault(); this.message('error_page'); } return; }
        if (this.busy || this.locked) return;
        if (action.matches('[data-clear]')) this.rows.forEach(row => row.querySelector('[data-quantity]').value = '0');
        else { const row = action.closest('[data-row]'); const { first, maximum, step, inCart } = this.limits(row); const value = this.quantity(row); row.querySelector('[data-quantity]').value = String(action.matches('[data-plus]') ? Math.min(maximum, Math.max(first, Math.ceil((inCart + value + 1) / step) * step - inCart)) : (value <= first ? 0 : Math.max(0, Math.floor((inCart + value - 1) / step) * step - inCart))); }
        this.querySelector('[data-message]').textContent = ''; this.update();
      }
      async addSelection(event) {
        event.preventDefault();
        if (this.busy || this.locked) return;
        const selected = this.rows.filter(row => this.quantity(row) > 0);
        if (!selected.length) { this.message('error_empty'); return; }
        if (selected.some(row => !this.valid(row))) { this.update(); return; }
        this.busy = true; this.update();
        this.request = new AbortController();
        const timer = setTimeout(() => this.request.abort(), 30000);
        let writeStarted = false;
        try {
          const sectionUrl = new URL(window.location.href); sectionUrl.searchParams.set('section_id', this.dataset.section);
          const [cartResponse, sectionResponse] = await Promise.all([
            fetch(`${this.dataset.cartUrl}.js`, { credentials: 'same-origin', cache: 'no-store', signal: this.request.signal }),
            fetch(sectionUrl, { credentials: 'same-origin', cache: 'no-store', signal: this.request.signal })
          ]);
          if (!cartResponse.ok || !sectionResponse.ok) throw new Error('preflight');
          const cart = await cartResponse.json();
          const fragment = new DOMParser().parseFromString(await sectionResponse.text(), 'text/html').querySelector('azuelos-pro-order');
          if (!fragment || fragment.dataset.location !== this.dataset.location || fragment.dataset.customer !== this.dataset.customer || cart.currency !== this.dataset.currency) { this.locked = true; this.message('error_session'); return; }
          const quantities = new Map();
          cart.items.forEach(item => quantities.set(String(item.variant_id), (quantities.get(String(item.variant_id)) || 0) + item.quantity));
          this.cartCount = cart.items.filter(item => !item.gift_card).reduce((sum, item) => sum + item.quantity, 0);
          let changed = false;
          for (const row of this.rows) {
            const fresh = fragment.querySelector(`[data-row][data-id="${row.dataset.id}"]`);
            if (!fresh) { if (this.quantity(row) > 0) changed = true; row.dataset.available = 'false'; }
            else {
              if (this.quantity(row) > 0 && row.dataset.price !== fresh.dataset.price) changed = true;
              for (const field of ['price', 'stock', 'min', 'max', 'step', 'available']) row.dataset[field] = fresh.dataset[field];
              row.querySelector('[data-unit-price]').textContent = fresh.querySelector('[data-unit-price]').textContent;
              row.querySelector('.az-pro__stock-label').textContent = fresh.querySelector('.az-pro__stock-label').textContent;
            }
            const before = Number(row.dataset.inCart) || 0;
            row.dataset.inCart = String(quantities.get(row.dataset.id) || 0);
            if (this.quantity(row) > 0 && before !== Number(row.dataset.inCart)) changed = true;
            row.querySelector('[data-in-cart-label]').textContent = Number(row.dataset.inCart) > 0 ? this.text('in_cart', { count: row.dataset.inCart }) : '';
            if (this.quantity(row) > 0 && !this.valid(row)) changed = true;
          }
          if (changed) { this.message('error_review'); return; }
          const items = selected.map(row => ({ id: row.dataset.id, quantity: this.quantity(row) }));
          writeStarted = true;
          const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', signal: this.request.signal, body: JSON.stringify({ items }) });
          if (!response.ok) { this.locked = true; this.message('error_server'); return; }
          this.locked = true;
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          if (writeStarted) this.locked = true;
          if (this.isConnected) this.message(writeStarted ? 'error_uncertain' : 'error_load');
        } finally { clearTimeout(timer); this.busy = false; if (this.isConnected) this.update(); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
